import { render, staticRenderFns } from "./ConstructorOpen.vue?vue&type=template&id=c5010908&scoped=true&"
import script from "./ConstructorOpen.vue?vue&type=script&lang=js&"
export * from "./ConstructorOpen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5010908",
  null
  
)

export default component.exports